import {createReducer, on} from '@ngrx/store';
import {EActionStatus} from 'src/app/shared/enums/action-status.enum';
import {INewOrderState} from '../models/new-order-state.model';
import {
  getProduct,
  loadProduct,
  loadProductById,
  LoadProductByIdFailure,
  LoadProductByIdSuccess,
  loadProductFailure,
  loadProductSuccess,
  resetProducts,
} from './new-order.actions';

const initialNewOrderState: INewOrderState = {
  productStatus: EActionStatus.Initial,
  products: [],
  selectedProduct: null,
};

export const newOrderReducer = createReducer(
  initialNewOrderState,
  on(loadProduct, state => ({
    ...state,
    productStatus: EActionStatus.Pending,
  })),
  on(loadProductSuccess, (state, {products}) => ({
    ...state,
    productStatus: EActionStatus.Success,
    products: products,
  })),
  on(loadProductFailure, state => ({
    ...state,
    productStatus: EActionStatus.Error,
    products: [],
  })),
  on(loadProductById, state => ({
    ...state,
    productStatus: EActionStatus.Pending,
  })),
  on(LoadProductByIdSuccess, (state, {products}) => ({
    ...state,
    productStatus: EActionStatus.Success,
    products: products,
  })),
  on(LoadProductByIdFailure, state => ({
    ...state,
    productStatus: EActionStatus.Error,
    products: [],
  })),
  on(getProduct, (state, {product}) => ({
    ...state,
    selectedProduct: product,
  })),
  on(resetProducts, state => ({
    ...state,
    productStatus: EActionStatus.Initial,
    products: [],
    selectedProduct: null,
  }))
);
